import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import ServicePage from "./pages/ServicePage";
import Services from "./pages/Services";
import Attorneys from "./pages/Attorneys";
import Intake from "./pages/Intake";
import IntakeGrievance from "./pages/IntakeGrievance";
import IntakeParole from "./pages/IntakeParole";
import IntakeDivorce from "./pages/IntakeDivorce";
import IntakeHearing from "./pages/IntakeHearing";
import DivorceOverview from "./pages/DivorceOverview";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import ComingSoon from "./pages/ComingSoon";
import PetitionPublic from "./pages/PetitionPublic";
import Community from "./pages/Community";
import CommunityPost from "./pages/CommunityPost";
import FAQ from "./pages/FAQ";
import Booking from "./pages/Booking";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import AdminClientDetail from "./pages/AdminClientDetail";
import Portal from "./pages/Portal";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback synchronously to avoid race
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/coming-soon" element={<ComingSoon />} />
        <Route path="/attorneys" element={<Attorneys />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/intake/grievance" element={<IntakeGrievance />} />
        <Route path="/intake/parole" element={<IntakeParole />} />
        <Route path="/intake/divorce" element={<IntakeDivorce />} />
        <Route path="/intake/hearing" element={<IntakeHearing />} />
        <Route path="/divorce-overview" element={<DivorceOverview />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/incarcerated" element={<ServicePage serviceKey="incarcerated" />} />
        <Route path="/families" element={<ServicePage serviceKey="families" />} />
        <Route path="/defense" element={<ServicePage serviceKey="defense" />} />
        <Route path="/hearings" element={<ServicePage serviceKey="hearings" />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/:postId" element={<CommunityPost />} />
        <Route path="/petitions/:slug" element={<PetitionPublic />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route
          path="/portal"
          element={
            <ProtectedRoute>
              <Portal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/clients/:clientId"
          element={
            <ProtectedRoute adminOnly>
              <AdminClientDetail />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
